import { Box, Stack } from "@mui/material";
import { Link } from "react-router-dom";

export default function NavLogo() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        minHeight: "100px",
        px: 2,
        marginBottom: "32px",
      }}
    >
      <Link
        to="/yb/yearBookingList"
        style={{
          textDecoration: "none",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: `70px`,
            height: `70px`,
            flexShrink: 0,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundImage: "url(/teeshot_logo.png)",
          }}
        />
        <Stack sx={{ flexDirection: "column", gap: 0.3 }}>
          <Box sx={{ fontSize: "20px", lineHeight: 1.2, color: "white" }}>
            TeeShot
          </Box>
          <Box sx={{ fontSize: "13px", lineHeight: 1.2, color: "white" }}>
            골프친구 티샷
          </Box>
        </Stack>
      </Link>
    </Box>
  );
}
